import {
  JOB_ADD_REQUEST,
  JOB_ADD_SUCCESS,
  JOB_ADD_FAIL,
  JOB_LIST_REQUEST,
  JOB_LIST_SUCCESS,
  JOB_LIST_FAIL,
  JOB_DETAILS_REQUEST,
  JOB_DETAILS_SUCCESS,
  JOB_DETAILS_FAIL,
  JOB_UPDATE_REQUEST,
  JOB_UPDATE_SUCCESS,
  JOB_UPDATE_FAIL,
  JOB_DELETE_REQUEST,
  JOB_DELETE_SUCCESS,
  JOB_DELETE_FAIL,
} from "../constences/jobConst";

import axios from "axios";

export const createJob = (job) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_ADD_REQUEST,
    });

    const response = await axios.post(
      "https://ccab-server.up.railway.app/api/job",
      job
    );

    // console.log("response:", response)

    dispatch({
      type: JOB_ADD_SUCCESS,
      //   payload: console.log("payload:", resconst response.data),
      payload: response.data,
    });
  } catch (error) {
    console.log("error:", error);
    dispatch({
      type: JOB_ADD_FAIL,
      //    payload: error.res
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getJobs = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_LIST_REQUEST,
    });

    // Descruct from getState()
    const {
      userLogin: { userDetail },
    } = getState();
    const config = {
      headers: {
        Authorization: "Bearer " + userDetail.token,
      },
    };
    const response = await axios.get(
      "https://ccab-server.up.railway.app/api/job/",
      config
    );
    dispatch({
      type: JOB_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    // console.log("error:", error)
    dispatch({
      type: JOB_LIST_FAIL,
      //    payload: error.res
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getRequestDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_DETAILS_REQUEST,
    });
    const {
      userLogin: { userDetail },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userDetail.token,
      },
    };

    const response = await axios.get(
      `https://ccab-server.up.railway.app/api/request/${id}`,
      config
    );

    dispatch({
      type: JOB_DETAILS_SUCCESS,
      payload: response.data.data,
      // payload: console.log("payload: ", response.data),
    });
  } catch (error) {
    console.log(error.response.data.message);
    dispatch({
      type: JOB_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteRequest = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_DELETE_REQUEST,
    });

    const {
      userLogin: { userDetail },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userDetail.token,
      },
    };

    await axios.delete(
      `https://ccab-server.up.railway.app/api/request/${id}`,
      config
    );

    dispatch({
      type: JOB_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: JOB_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// update Request
export const updateRequest = (req, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_UPDATE_REQUEST,
    });

    const {
      userLogin: { userDetail },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userDetail.token,
      },
    };

    //console.log(REQUEST);
    await axios.put(
      `https://ccab-server.up.railway.app/api/request/${id}`,
      req,
      config
    );

    dispatch({
      type: JOB_UPDATE_SUCCESS,
    });
  } catch (error) {
    // console.log(error.response.data);
    dispatch({
      type: JOB_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
